/* eslint-disable no-console */
import React from "react";
import { useDispatch } from "react-redux";
import { PageToolbar } from "../../molecules";
import { useFirestoreCollection } from "../../../hooks/useFirestoreCollection";
import { fetchProduction67969FromFirestore } from "../../../firestore/firestoreService";
import { listenToProduction67969 } from "../../../redux/data/production67969/production67969Actions";
import { productionStatusTypes } from "../../../enums";

export const FleetProductionsToolbar: React.FC = () => {
  const dispatch = useDispatch();
  useFirestoreCollection({
    query: () =>
      fetchProduction67969FromFirestore([
        {
          type: "filter",
          name: "status",
          opr: "==",
          value: productionStatusTypes.DISTRIBUTED.value,
        },
      ]),
    data: listenToProduction67969,
    deps: [dispatch],
  });

  return (
    <PageToolbar>
      <div></div>
      <div className="page-toolbar-right-children-elements"></div>
    </PageToolbar>
  );
};
